import { hasUnsavedFormChanges } from "../../../common/formStateDirty";

type ChamberProfileWorkInput<Value> = {
  activeImageReadCount: number;
  baseline: Value;
  current: Value;
};

type ChamberProfileHydrationInput<Value> = ChamberProfileWorkInput<Value> & {
  activeChamberId: string;
  incomingChamberId: string;
};

export const hasUnsavedChamberProfileWork = <Value>({
  activeImageReadCount,
  baseline,
  current,
}: ChamberProfileWorkInput<Value>): boolean =>
  activeImageReadCount > 0 || hasUnsavedFormChanges({ baseline, current });

export const shouldHydrateChamberProfile = <Value>({
  activeChamberId,
  activeImageReadCount,
  baseline,
  current,
  incomingChamberId,
}: ChamberProfileHydrationInput<Value>): boolean =>
  !activeChamberId ||
  activeChamberId !== incomingChamberId ||
  !hasUnsavedChamberProfileWork({
    activeImageReadCount,
    baseline,
    current,
  });
